import React from 'react';
import { Container, Row, Col, Nav, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  const footerLinks = [
    {
      title: 'Company',
      links: [
        { name: 'About Us', path: '/about' },
        { name: 'Contact', path: '/contact' },
        { name: 'Careers', path: '/careers' },
        { name: 'Press', path: '/press' },
      ],
    },
    {
      title: 'For Businesses',
      links: [
        { name: 'Join Network', path: '/register?role=business' },
        { name: 'Business Benefits', path: '/business-benefits' },
        { name: 'Success Stories', path: '/success-stories' },
        { name: 'Pricing', path: '/pricing' },
      ],
    },
    {
      title: 'For Affiliates',
      links: [
        { name: 'Become an Affiliate', path: '/register?role=affiliate' },
        { name: 'Commission Structure', path: '/commissions' },
        { name: 'Affiliate Tools', path: '/affiliate-tools' },
      ],
    },
    {
      title: 'Support',
      links: [
        { name: 'Help Center', path: '/help' },
        { name: 'FAQ', path: '/faq' },
        { name: 'Card Activation', path: '/activate' },
        { name: 'Check Balance', path: '/check-balance' },
      ],
    },
  ];

  return (
    <footer className="bg-dark text-light py-5 mt-auto">
      <Container>
        <Row>
          {footerLinks.map((column) => (
            <Col xs={12} sm={6} md={3} key={column.title} className="mb-4">
              <h5>{column.title}</h5>
              <Nav className="flex-column">
                {column.links.map((link) => (
                  <Nav.Link 
                    as={Link} 
                    to={link.path} 
                    key={link.name}
                    className="ps-0 text-light opacity-75"
                  >
                    {link.name}
                  </Nav.Link>
                ))}
              </Nav>
            </Col>
          ))}
        </Row>

        <hr className="my-4 bg-secondary" />
        
        <Row className="align-items-center">
          <Col xs={12} md={6} className="text-center text-md-start mb-3 mb-md-0">
            <p className="text-muted mb-0">
              © {currentYear} Gift Card Exchange. All rights reserved.
            </p>
          </Col>
          
          <Col xs={12} md={6}>
            <div className="d-flex justify-content-center justify-content-md-end">
              <Button variant="dark" className="me-2" aria-label="Facebook">
                <i className="bi bi-facebook"></i>
              </Button>
              <Button variant="dark" className="me-2" aria-label="Twitter">
                <i className="bi bi-twitter"></i>
              </Button>
              <Button variant="dark" className="me-2" aria-label="Instagram">
                <i className="bi bi-instagram"></i>
              </Button>
              <Button variant="dark" aria-label="LinkedIn">
                <i className="bi bi-linkedin"></i>
              </Button>
            </div>
          </Col>
        </Row>
        
        <Row className="mt-3">
          <Col className="text-center">
            <Nav className="justify-content-center">
              <Nav.Link as={Link} to="/privacy" className="text-muted px-2">Privacy Policy</Nav.Link>
              <Nav.Link as={Link} to="/terms" className="text-muted px-2">Terms of Service</Nav.Link>
              <Nav.Link as={Link} to="/content-editor" className="text-muted px-2">Content Editor</Nav.Link>
            </Nav>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer; 